// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"e1233731","284":"5f4cc0fe","455":"8da75d88","829":"6c8cec8b","919":"fad78eaa"}[chunkId] + ".chunk.js";
};